// author @xys
// 获取微信用户信息，头像，昵称，openid
// 在混入该js文件后，定义回调方法名称，并主动调用 toAuthorizationPage 方法
import { appid, getUserAccessToken, getWxUserInfo } from "@/utils/api/wx";
import store from "@/store";
// 检查是否过期
export const expiredChecked = (temp) => {
  const now = Date.parse(new Date()) / 1000;
  const ex = now >= parseInt(temp);
  return ex;
};
export const wxlogin = {
  methods: {
    // 点击事件调起微信授权流程
    /**
     *
     * @param {*} callbackNameStr 表示 vue 文件中的会掉方法的名称 非必填
     * @param {*} redirectUrl 标识需要重定向的url 非必填（非必填，默认当前路径为重定向路径）
     */
    toAuthorizationPage(callbackNameStr = "", redirectUrl = "", params = []) {
      let userAccessToken = store.state.userAccessToken;
      // 设置重定向识别参数
      let url;
      if (redirectUrl) {
        url = redirectUrl;
      } else {
        url = window.location.href;
      }
      let state;
      if ( !userAccessToken.access_token || expiredChecked(userAccessToken.expire_timestamp)) {
        // token 过期
        url = encodeURI(url);
        state = `1`;
        if (callbackNameStr) state += `,${callbackNameStr}`;
        if (params.length) {
          params.forEach((e) => {
            state += `,${e}`;
          });
        }
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
      } else {
        // token 未过期
        state = `2`;
        if (callbackNameStr) state += `,${callbackNameStr}`;
        if (params.length) {
          params.forEach((e) => {
            state += `,${e}`;
          });
        }
        url += `?state=${state}`;
        url = encodeURI(url);
        window.location.href = decodeURIComponent(url);
      }
    },
    // 通过token，openid 获取用户信息
    async fnGetWxUserInfo(access_token, openid, callbackNameStr = "") {
      const { data: wxUserInfo } = await getWxUserInfo(access_token, openid);
      console.log('获取用户信息',wxUserInfo)
      let callback;
      if (callbackNameStr) {
        callback = this[callbackNameStr];
      }
      if (!wxUserInfo.errcode) {
        store.commit("SET_WX_USERINFO", wxUserInfo);
        if (typeof callback === "function") {
          callback(wxUserInfo);
        }
      } else {
        this.$root.$toast.fail(wxUserInfo.errmsg);
      }
    }
  },
  async mounted() {
    const state = this.$route.query.state;
    if (!state) {
      return;
    }
    const isRedirect = state.split(",")[0];
    const callbackNameStr = state.split(",")[1];
    if (isRedirect == 1) {
      // token 已过期
      const code = this.$route.query.code;
      // 通过code 获取必要参数
      const res = await getUserAccessToken(code);
      let openid, access_token;
      if (!res.data.errcode) {
        openid = res.data.openid;
        access_token = res.data.access_token;
        // 缓存token 及过期时间
        store.commit("SET_USER_ACCESS_TOKEN", {
          access_token,
          expire_timestamp:
            Date.parse(new Date()) / 1000 + parseInt(res.data.expires_in)
        });
        store.commit("SET_OPENID", openid);
        this.fnGetWxUserInfo(access_token, openid, callbackNameStr);
      } else {
        this.$root.$toast.fail(res.data.errmsg);
      }
    } else if (isRedirect == 2) {
      // token 未过期
      let userAccessToken = store.state.userAccessToken;
      const access_token = userAccessToken.access_token,
        openid = store.state.openid;
      this.fnGetWxUserInfo(access_token, openid, callbackNameStr);
    }
  }
};
